module.exports = __webpack_public_path__ + "img/20210625_Teilkauf_2897.206a4b6f.png";